<template>
  <div class="sales-ranking">
    <div class="module-header">
      <h3 class="module-title">单品销售码洋排行榜</h3>
      <div class="time-selector">
        <button 
          v-for="option in timeOptions" 
          :key="option.value"
          :class="['time-btn', { active: selectedPeriod === option.value }]"
          @click="changePeriod(option.value)"
        >
          {{ option.label }}  
        </button>
      </div>
    </div>
    <div class="rank_list">
      <dv-scroll-board :config="config" style="width:412px;height:238px" />
    </div>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: "SalesRanking",
  data () {
    return {
      selectedPeriod: 'week',
      timeOptions: [
        { label: '近7天', value: 'week' },
        { label: '本月', value: 'month' },
        { label: '近半年', value: 'halfyear' },
      ],
      boardStyle: {
        waitTime: 2500,
        headerBGC: '#0E4B8B',
        oddRowBGC: 'rgba(14, 75, 139, 0.35)',
        evenRowBGC: 'transparent',
        columnWidth: [48, 140, 70, 90],
        align: ['center', 'left', 'center', 'center', 'center'],
        carousel: 'page'
      }
    }
  },
  computed: {
    ...mapState(['salesRanking']),
    config() {
      return {
        header: ['NO', '品名', '定价', '销售码洋', '销售数量'],
        data: Array.isArray(this.salesRanking?.rows) ? this.salesRanking.rows : [],
        ...this.boardStyle
      }
    }
  },
  mounted() {
    this.fetchSalesRanking(this.selectedPeriod)
  },
  methods: {
    ...mapActions(['fetchSalesRanking']),
    changePeriod(period) {
      if (this.selectedPeriod === period) return
      this.selectedPeriod = period
      this.fetchSalesRanking(period)
    }
  },
};
</script>
 
<style lang="scss" scoped>
.book-statistics {
  height: 100%;
  display: flex;
  flex-direction: column;
  .rank_list {
    width: 100%;
    height: 240px;
  }
}
::v-deep .dv-scroll-board {
  .header {
    font-size: 12px;
    .header-item {
      padding: 0 5px;
      &:nth-of-type(2) {
        text-align: center;
      }
    }
  }
  .rows {
    .ceil {
      padding: 0 5px;
      &:first-child {
        display: flex;
        align-items: center;
      }
      .rank_card {
        width: 46px;
        height: 21px;
        background: url("@/assets/images/rank_b.png") no-repeat center center;
        background-size: 100% auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000000;
        font-size: 12px;
        &.top3 {
          background: url("@/assets/images/rank_y.png") no-repeat center center;
          background-size: 100% auto;
        }
      }
    }
  }
}
</style>